module.exports = __webpack_public_path__ + "media/images/emblems/Hasliberg-coat_of_arms-2eb18e23e27dea4284013441fc929282.svg";